// Auto-generated from client case studies (50 verified client dashboards).
export const CASE_STUDIES = [
  {
    "name": "Marcus",
    "sub": "Home & Kitchen · 6 months in",
    "badge": "+1080%",
    "amt": "$444.6K",
    "per": "year to date",
    "quote": "Woke up to a $70k day. Still doesn't feel real.",
    "img": "https://lh3.googleusercontent.com/d/1VRaVbvwSE31abb0dMo7cns7YTU6Bm3_b=w700"
  },
  {
    "name": "Marcus",
    "sub": "Home & Kitchen · 6 months in",
    "badge": "+5121%",
    "amt": "$120.6K",
    "per": "this week",
    "quote": "Best week the store has ever had.",
    "img": "https://lh3.googleusercontent.com/d/1xE9HLKY6gWxoE3QqMkUVAiTT7JNbeKaU=w700"
  },
  {
    "name": "Marcus",
    "sub": "Home & Kitchen · 6 months in",
    "badge": "+1081%",
    "amt": "$444.8K",
    "per": "year to date",
    "quote": "274 units before dinner time.",
    "img": "https://lh3.googleusercontent.com/d/1FTKxigMBTEq0cfa31WGprfr9H0MBEUt5=w700"
  },
  {
    "name": "Danielle",
    "sub": "Pet Supplies · 6 months in",
    "badge": "+889%",
    "amt": "$371.1K",
    "per": "year to date",
    "quote": "I check the app once a day. That's my whole job now.",
    "img": "https://lh3.googleusercontent.com/d/1gQDwAG_5TO453dikXzJNn99ljtHgxmB-=w700"
  },
  {
    "name": "Tyler",
    "sub": "Home Improvement · 14 months in",
    "badge": "+141%",
    "amt": "$247.3K",
    "per": "last 12 months",
    "quote": "Six figures, fully automated.",
    "img": "https://lh3.googleusercontent.com/d/1VtFXfROiQdSg72BRzjHgBpP6Osp5hIA8=w700"
  },
  {
    "name": "Omar",
    "sub": "Health & Household · 5 months in",
    "badge": "+106%",
    "amt": "$172.8K",
    "per": "last 30 days",
    "quote": "Consistent five-figure days with third-party suppliers.",
    "img": "https://lh3.googleusercontent.com/d/1UVK2cF3U5GXRdTDREjw4CB_P6Y-Y_DDm=w700"
  },
  {
    "name": "Priya",
    "sub": "Beauty · 6 months in",
    "badge": "+5589%",
    "amt": "$158.3K",
    "per": "this week",
    "quote": "A $35k Saturday. I had to screenshot it.",
    "img": "https://lh3.googleusercontent.com/d/1tK3urIlajRmLxnqOGVC9iWMjuJcaZ-Fd=w700"
  },
  {
    "name": "Jessica",
    "sub": "Kitchen & Dining · 12 months in",
    "badge": "",
    "amt": "$159.6K",
    "per": "last 12 months",
    "quote": "Nearly $20k in a single day this month.",
    "img": "https://lh3.googleusercontent.com/d/11_bC-oxVVzhUEjmBXQHrz3cgKtB-7jHR=w700"
  },
  {
    "name": "Amara",
    "sub": "Office Products · 6 months in",
    "badge": "",
    "amt": "$106.6K",
    "per": "year to date",
    "quote": "Joined the 100k club with an almost $10k day.",
    "img": "https://lh3.googleusercontent.com/d/1o1S6vMFKw4352Q91a4SGPXBE2cY3z5ky=w700"
  },
  {
    "name": "Derek",
    "sub": "Toys & Games · 6 months in",
    "badge": "",
    "amt": "$107.7K",
    "per": "year to date",
    "quote": "From zero to six figures in half a year.",
    "img": "https://lh3.googleusercontent.com/d/1rsyIzdmYdPfYnKkpU-SeFze-Vikg0DSR=w700"
  },
  {
    "name": "Sofia",
    "sub": "Garden & Outdoor · 6 months in",
    "badge": "+591%",
    "amt": "$111.0K",
    "per": "year to date",
    "quote": "The chart only goes one direction.",
    "img": "https://lh3.googleusercontent.com/d/1Ar0VWM1GC9IlK1V7L7U6l-bqETOexicn=w700"
  },
  {
    "name": "Chris",
    "sub": "Grocery · 7 months in",
    "badge": "",
    "amt": "$111,964",
    "per": "year to date",
    "quote": "2,687 units ordered and counting.",
    "img": "https://lh3.googleusercontent.com/d/10OEOoY3epH4VGrDjGkPPelr6BiXgcPuC=w700"
  },
  {
    "name": "Latoya",
    "sub": "Home & Kitchen · 8 months in",
    "badge": "",
    "amt": "$75,005.53",
    "per": "bi-weekly payout",
    "quote": "The payout notifications never get old.",
    "img": "https://lh3.googleusercontent.com/d/1eJgncelpLu9w_ErmBfspWaiMwbrK-Sol=w700"
  },
  {
    "name": "Ryan",
    "sub": "Health & Household · 7 months in",
    "badge": "",
    "amt": "$55,888.03",
    "per": "bi-weekly payout",
    "quote": "Back-to-back $40k+ payouts.",
    "img": "https://lh3.googleusercontent.com/d/1LKTzsQ79RHc5BDiTUsZJFcBVq-JQFJmg=w700"
  },
  {
    "name": "Rachel",
    "sub": "Home Essentials · 4 months in",
    "badge": "+2598%",
    "amt": "$58.90K",
    "per": "this month",
    "quote": "Nice payout on its way.",
    "img": "https://lh3.googleusercontent.com/d/1hJS68MT5KdKLK3kkeiDqIfWtZecHvhXc=w700"
  },
  {
    "name": "Sam",
    "sub": "Sports & Outdoors · First month",
    "badge": "+421%",
    "amt": "$55.41K",
    "per": "first month",
    "quote": "$55k in the very first month on an aged account.",
    "img": "https://lh3.googleusercontent.com/d/1XKk165i9I18mUp2pVnwDp1uY6okOs9Ss=w700"
  },
  {
    "name": "John",
    "sub": "Tools & Auto · 3 months in",
    "badge": "+111%",
    "amt": "$44.89K",
    "per": "in March",
    "quote": "A $44k March. Zero hours worked.",
    "img": "https://lh3.googleusercontent.com/d/10ElTkUke_A5ujf_jU3FXZNARFKSy8i8H=w700"
  },
  {
    "name": "Nicole",
    "sub": "Beauty & Care · 6 months in",
    "badge": "",
    "amt": "$43,969.85",
    "per": "Jan – Jun",
    "quote": "1,192 units shipped while I kept my day job.",
    "img": "https://lh3.googleusercontent.com/d/1kDYdP8zdUfh7AqTY2cuxIjLH52Xkrrcq=w700"
  },
  {
    "name": "Victor",
    "sub": "Household Goods · 5 months in",
    "badge": "",
    "amt": "$40,867.62",
    "per": "month to date",
    "quote": "2,444 units this month alone.",
    "img": "https://lh3.googleusercontent.com/d/1UMBq9_rpAApm-GzigCMfnuMzh2O1xkIT=w700"
  },
  {
    "name": "Jordan",
    "sub": "Pet Supplies · 6 months in",
    "badge": "",
    "amt": "$35,155.18",
    "per": "bi-weekly payout",
    "quote": "Biggest settlement yet.",
    "img": "https://lh3.googleusercontent.com/d/1G1oWq2yw5ZV8WX0EJBEtPySy6Ri9MRA3=w700"
  },
  {
    "name": "Tina",
    "sub": "Kitchen & Dining · 5 months in",
    "badge": "+69%",
    "amt": "$35.18K",
    "per": "last 12 months",
    "quote": "Let's go — another record month.",
    "img": "https://lh3.googleusercontent.com/d/1FAcFcaPMhxKtbowWSxAbCYGNJUwdxjff=w700"
  },
  {
    "name": "Devon",
    "sub": "Books & Media · 2 months in",
    "badge": "+19752%",
    "amt": "$30.52K",
    "per": "last 30 days",
    "quote": "18–30% net margins with third-party suppliers.",
    "img": "https://lh3.googleusercontent.com/d/1SQSB2ZfI4A_JsjKu6VFvBD0AsauThcZL=w700"
  },
  {
    "name": "Hannah",
    "sub": "Home & Kitchen · 3 months in",
    "badge": "",
    "amt": "$30,357.77",
    "per": "scheduled payout",
    "quote": "We took this store over from another automation company.",
    "img": "https://lh3.googleusercontent.com/d/1kWMDkCqL5PfE1GeWxFq4L3vldcg5VVFQ=w700"
  },
  {
    "name": "Laura",
    "sub": "Health & Beauty · 3 months in",
    "badge": "+89%",
    "amt": "$30.65K",
    "per": "in March",
    "quote": "Over $30k in a single month.",
    "img": "https://lh3.googleusercontent.com/d/1gmzcPM0CJG_GE21M-Iqkv2l8SZkG7Qcl=w700"
  },
  {
    "name": "Isaiah",
    "sub": "Electronics · 2 months in",
    "badge": "+1159%",
    "amt": "$26.06K",
    "per": "last 30 days",
    "quote": "New store scaling faster than expected.",
    "img": "https://lh3.googleusercontent.com/d/128BI0hljH3bn4EMbVSECaWpxUO70Mr0O=w700"
  },
  {
    "name": "Monica",
    "sub": "Grocery · 3 months in",
    "badge": "",
    "amt": "$23,342.86",
    "per": "Apr – Jun",
    "quote": "1,148 units in the first quarter.",
    "img": "https://lh3.googleusercontent.com/d/113hB3evjWRqFXsfweRVxcUzM9YPQL6lc=w700"
  },
  {
    "name": "Carlos",
    "sub": "Office Products · 4 months in",
    "badge": "",
    "amt": "$20,578.46",
    "per": "scheduled payout",
    "quote": "Direct to my bank, every two weeks.",
    "img": "https://lh3.googleusercontent.com/d/14pDHZiFPnDogfp8d_ofYZh6ysFaz8cnv=w700"
  },
  {
    "name": "Grant",
    "sub": "Home Improvement · 2 months in",
    "badge": "",
    "amt": "$19,182.38",
    "per": "month to date",
    "quote": "1,065 units ordered this month.",
    "img": "https://lh3.googleusercontent.com/d/17SrSIy1TPPkDoOiDy0pZfdcAj5CeGy5e=w700"
  },
  {
    "name": "Alyssa",
    "sub": "Garden & Outdoor · 6 weeks in",
    "badge": "+34%",
    "amt": "$19.24K",
    "per": "last 30 days",
    "quote": "Slow and steady — 100% automated.",
    "img": "https://lh3.googleusercontent.com/d/1yDReYOCl2-Kgibyqz1uw3fQaVy14fpcX=w700"
  },
  {
    "name": "Brandon",
    "sub": "Household Goods · 3 months in",
    "badge": "+108%",
    "amt": "$17.91K",
    "per": "in March",
    "quote": "An extra $17k of income this March.",
    "img": "https://lh3.googleusercontent.com/d/1OxKMBx0SvOb0v-EdCJBMlurLE00nFTDp=w700"
  },
  {
    "name": "Trevor",
    "sub": "Sports & Outdoors · 3 months in",
    "badge": "",
    "amt": "$16,883.79",
    "per": "Apr – Jun",
    "quote": "894 units without touching a thing.",
    "img": "https://lh3.googleusercontent.com/d/1YP0K-C6OkuaQAvRH1TcHNs7lkncetcV_=w700"
  },
  {
    "name": "Dana",
    "sub": "Beauty & Care · Month 2",
    "badge": "",
    "amt": "$16.66K",
    "per": "this month",
    "quote": "$16k already in month two.",
    "img": "https://lh3.googleusercontent.com/d/1Jl6m-UiW6ZudvNDmSU4A1w0g2JrTVu9i=w700"
  },
  {
    "name": "Nancy",
    "sub": "Home Essentials · Month 2",
    "badge": "+128%",
    "amt": "$16.08K",
    "per": "this month",
    "quote": "Over $16k in my second month!",
    "img": "https://lh3.googleusercontent.com/d/1ql9DzmNZhcI1rLnT59DFeoJqLia4j9bM=w700"
  },
  {
    "name": "Felix",
    "sub": "Toys & Games · 5 months in",
    "badge": "",
    "amt": "$13.59K",
    "per": "last 12 months",
    "quote": "New month, new record.",
    "img": "https://lh3.googleusercontent.com/d/1gh5vZJa3AAzcuhmmI2cwxl1v3FvFl2Dr=w700"
  },
  {
    "name": "Emily",
    "sub": "Pet Supplies · 2 months in",
    "badge": "",
    "amt": "$10,120.51",
    "per": "scheduled payout",
    "quote": "First five-figure payout.",
    "img": "https://lh3.googleusercontent.com/d/1AMcWsktch31imdYpKcO54JRrWPZQeXsA=w700"
  },
  {
    "name": "Paige",
    "sub": "Health & Household · 2 months in",
    "badge": "",
    "amt": "$10,124.76",
    "per": "month to date",
    "quote": "Up 50% on last month already.",
    "img": "https://lh3.googleusercontent.com/d/1S4Tv2ImyZw63mwGPc_Df9HJ2ak9nzxkj=w700"
  },
  {
    "name": "Miguel",
    "sub": "Kitchen & Dining · 2 months in",
    "badge": "",
    "amt": "$8,715.32",
    "per": "month to date",
    "quote": "$36 average order and climbing.",
    "img": "https://lh3.googleusercontent.com/d/1vNJ50raWVNVcIBmJ9weMEOa3nEXZQ9bR=w700"
  },
  {
    "name": "Matthew",
    "sub": "Home & Kitchen · First month",
    "badge": "+301%",
    "amt": "$6,821",
    "per": "first month",
    "quote": "Over $6k in my first month.",
    "img": "https://lh3.googleusercontent.com/d/1vUduSD1HuguPUBb-kZCKS_9aLUtDR17z=w700"
  },
  {
    "name": "Andre",
    "sub": "Electronics · 6 weeks in",
    "badge": "",
    "amt": "$6,511.06",
    "per": "scheduled payout",
    "quote": "Payouts started week three.",
    "img": "https://lh3.googleusercontent.com/d/1axuDkIbYIJ2UapgfTIWbKYlJWxKzSLaC=w700"
  },
  {
    "name": "Erica",
    "sub": "Household Goods · 4 months in",
    "badge": "",
    "amt": "$5,822.91",
    "per": "today's sales",
    "quote": "993 open orders this morning.",
    "img": "https://lh3.googleusercontent.com/d/1wfN0eE03uiIK_PCrmSOw-zH8dwPnqHnH=w700"
  },
  {
    "name": "Cole",
    "sub": "Grocery · First week",
    "badge": "",
    "amt": "$5,285",
    "per": "last 7 days",
    "quote": "#NEWSTORE — first week live.",
    "img": "https://lh3.googleusercontent.com/d/1hNkO2wZ3qdPRQArmlOwDXG1qTNuZYK6s=w700"
  },
  {
    "name": "Jasmine",
    "sub": "Office Products · First month",
    "badge": "+417%",
    "amt": "$5,278",
    "per": "last 30 days",
    "quote": "Brand-new store finding its rhythm.",
    "img": "https://lh3.googleusercontent.com/d/16MXj7acGkt2O9aSmqIEOzWZRaVMhRFlN=w700"
  },
  {
    "name": "Blake",
    "sub": "Home Improvement · 4 months in",
    "badge": "",
    "amt": "$4,850.42",
    "per": "today's sales",
    "quote": "924 open orders before lunch.",
    "img": "https://lh3.googleusercontent.com/d/1RlToE49tAfjapmebFpJzIlZ__3xTWyjE=w700"
  },
  {
    "name": "Renee",
    "sub": "Beauty · First week",
    "badge": "+104%",
    "amt": "$4,059",
    "per": "first week",
    "quote": "#FIRSTWEEK and already profitable.",
    "img": "https://lh3.googleusercontent.com/d/15cSobvOOVTZ9qrVXcdpiYyhBZE3PaV8u=w700"
  },
  {
    "name": "Owen",
    "sub": "Grocery · 3 months in",
    "badge": "",
    "amt": "$2,852.40",
    "per": "today's sales",
    "quote": "192 units before noon.",
    "img": "https://lh3.googleusercontent.com/d/1Tyb6mBTLOwwWkCtberEiUG5hyvKrE7E1=w700"
  },
  {
    "name": "Shawn",
    "sub": "Books & Media · 6 months in",
    "badge": "",
    "amt": "$2,428",
    "per": "year to date",
    "quote": "Small store, steady climb.",
    "img": "https://lh3.googleusercontent.com/d/1DNzin7EWMJncGo0oWjU1rdZv9XwdKQ4i=w700"
  },
  {
    "name": "Bianca",
    "sub": "Health & Household · 5 months in",
    "badge": "",
    "amt": "$2,177.10",
    "per": "today's sales",
    "quote": "$30k balance waiting on payout.",
    "img": "https://lh3.googleusercontent.com/d/1wg4dT5Ix9YL-oqJeTn710jKF1sr4KrjW=w700"
  },
  {
    "name": "Nadia",
    "sub": "Home Essentials · 3 months in",
    "badge": "+3956%",
    "amt": "$1,781",
    "per": "last 7 days",
    "quote": "The new store is kicking in.",
    "img": "https://lh3.googleusercontent.com/d/1bqvibwYaBQ34zFBR-rXEOKfVMkoxyCH-=w700"
  },
  {
    "name": "Kayla",
    "sub": "Pet Supplies · First month",
    "badge": "",
    "amt": "$1,002.21",
    "per": "today's sales",
    "quote": "First $1k day.",
    "img": "https://lh3.googleusercontent.com/d/1NFWlm77M1NN1V_bCLFWw7AYaBSw2oOP4=w700"
  },
  {
    "name": "Marco",
    "sub": "Facebook Shop · 6 months in",
    "badge": "",
    "amt": "$63,183.30",
    "per": "Jan – Jun",
    "quote": "4,362 purchases through the shop.",
    "img": "https://lh3.googleusercontent.com/d/1HB-yCEgOTqXqEv9q3UFEJN5f5M_yrqHZ=w700"
  }
];
